import { EmailPasswordLogin } from "./login";

export const Form = {
  EmailPasswordLogin
};
